
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'theme-ui';
import UserIcon from '@src/assets/icons/ic_profile.svg';
import { useUser } from '@src/services/userContext';
import './LoginButton.scss';

type LoginButtonProps = {
  onLoginIn: () => void;
};

const LoginButton = ({ onLoginIn }: LoginButtonProps) => {
  const { t } = useTranslation();
  const user = useUser();

  const handleLoginClick = () => {
    if (user?.userToken) {
      window.location.href = process.env.GATSBY_ADMIN_APP_URL || '';
    } else {
      onLoginIn();
    }
  };

  return (
    <Button
      variant="inverted"
      className="navbar__item navbar__login-button"
      sx={{
        color: 'white',
        padding: '8px 26px',
        marginLeft: 4,
        marginRight: 4,
        display: ['none', 'inline-block'],
      }}
      onClick={handleLoginClick}
    >
      {user?.userToken && (
        <>
          <UserIcon sx={{ size: '20px', marginRight: 2 }} />
          {t('myProfile')}
        </>
      )}
      {!user?.userToken && t('logIn')}
    </Button>
  );
};

export default LoginButton;
